import { API_KEY } from "config";

/**
 * 認証に関するユーティリティクラス
 */
export default class Auth {
  /**
   * APIキーを返却する
   * @returns APIキー
   */
  static apikey() {
    return API_KEY;
  }
}
